/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { useRef, useCallback, useState, Fragment } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useHistory } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import { CircularProgress } from "@material-ui/core";
import Model from "../../components/modal";

function createData(
  bookingNumber,
  dateReceived,
  patientId,
  patientName,
  natureOfConsult,
  bookingDate,
  bookingTime,
  facrrmOnly,
  action
) {
  return {
    bookingNumber,
    dateReceived,
    patientId,
    patientName,
    natureOfConsult,
    bookingDate,
    bookingTime,
    facrrmOnly,
    action
  };
}

export default function MyAppointmentTableSticky() {
  const history = useHistory();
  const observer = useRef();
  const [pageNo, setPageNumber] = useState(1);
  const [nextPage, setNextPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [callClinicPatientModel, setCallClinicPatientModelOpen] = useState(
    false
  );

  // Cancel Booking
  const [cancelBookingModel, setcancelBookingModel] = useState(false);

  const cancelBooking = () => {    
    setcancelBookingModel(false);
  };

  const openCancelBookingModel = (event, no) => {
    event.stopPropagation();
    setcancelBookingModel(true);
  };

  const closeCancelBookingModel = (event, no) => {
    event.stopPropagation();
    setcancelBookingModel(false);
  };

  // Completed Booking
  const [completeBookingModel, setcompleteBookingModel] = useState(false);

  const completeBooking = () => {
    console.log("Complete booking now");
    setcompleteBookingModel(false);
  };

  const openCompleteBookingModel = (event, no) => {
    event.stopPropagation();
    setcompleteBookingModel(true);
  };

  const closeCompleteBookingModel = (event, no) => {
    event.stopPropagation();
    setcompleteBookingModel(false);
  };

  // Column Names
  const columns = [
    {
      id: "bookingNumber",
      label: "Booking Number"
    },
    {
      id: "dateReceived",
      label: "Date Received"
    },
    {
      id: "patientId",
      label: "UIN"
    },
    {
      id: "patientName",
      label: "Patient Name"
    },
    {
      id: "natureOfConsult",
      label: "Nature of Consult"
    },
    {
      id: "bookingDate",
      label: "Booking Date"
    },
    {
      id: "bookingTime",
      label: "Booking Time (Brisbane Time)"
    },
    {
      id: "facrrmOnly",
      label: "FRACGP/ FACRRM Only"
    },
    {
      id: "action",
      label: "Action"
    }
  ];

  // Data to be appended
  const [rows, setRows] = useState([
    createData(
      "241",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "242",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "243",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "244",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "245",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "246",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "247",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "248",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "249",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "250",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    ),
    createData(
      "251",
      "06-02-2020",
      "112421",
      "Brenda Eddison",
      "Radiology Request Created",
      "26-08-2019",
      "04:00 PM",
      "No"
    )
  ]);

  const appendRows = [];

  const goTo = (event, no) => {
    history.push({
      pathname: appRoutes.viewAppointment + "/" + no,
      state: {
        from: 0
      }
    });
  };

  const callClinicPatient = (event, bookingNo) => {
    event.stopPropagation();
    console.log("Booking No: ", bookingNo);
    setCallClinicPatientModelOpen(true);
  };

  const callNow = () => {
    console.log("Calling now here is the data");
    setCallClinicPatientModelOpen(false);
  };

  const closeClinicModel = () => {
    setCallClinicPatientModelOpen(false);
  };

  const lastElementRef = useCallback(node => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(data => {
      if (data)
        if (data[0].isIntersecting && nextPage) {
          setLoading(true);
          console.log("Visible :", data);
          setPageNumber(pageNo => pageNo + 1);
          console.log(pageNo);
          if (!appendRows.length) setNextPage(false);
          setRows(rows.concat(appendRows));
          setLoading(false);
        }
    });
    if (node) observer.current.observe(node);
  });

  return (
    <Fragment>
      <Paper className="w-100">
        <TableContainer className="table-max-height primary-table-color my-open-appointment-table">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell key={column.id} align={column.align}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => {
                if (rows.length === index + 1) {
                  return (
                    <TableRow
                      className="cursor-pointer"
                      ref={lastElementRef}
                      hover
                      key={row.bookingNumber}
                      onClick={event => goTo(event, row.bookingNumber)}
                    >
                      <TableCell>{row.bookingNumber}</TableCell>

                      <TableCell>{row.dateReceived}</TableCell>

                      <TableCell>{row.patientId}</TableCell>

                      <TableCell>{row.patientName}</TableCell>

                      <TableCell>{row.natureOfConsult}</TableCell>

                      <TableCell>{row.bookingDate}</TableCell>

                      <TableCell>{row.bookingTime}</TableCell>

                      <TableCell>{row.facrrmOnly}</TableCell>

                      <TableCell>
                        <i
                          className="fas fa-video primary-color cursor-pointer font-17"
                          onClick={event =>
                            callClinicPatient(event, row.bookingNumber)
                          }
                        ></i>

                        <i
                          className="fas fa-times text-danger cursor-pointer font-17 ml-3"
                          onClick={event =>
                            openCancelBookingModel(event, row.bookingNumber)
                          }
                        ></i>

                        <i
                          className="fas fa-check text-success cursor-pointer font-17 ml-3"
                          onClick={event =>
                            openCompleteBookingModel(event, row.bookingNumber)
                          }
                        ></i>
                      </TableCell>
                    </TableRow>
                  );
                } else {
                  return (
                    <TableRow
                      className="cursor-pointer"
                      hover
                      key={row.bookingNumber}
                      onClick={event => goTo(event, row.bookingNumber)}
                    >
                      <TableCell>{row.bookingNumber}</TableCell>

                      <TableCell>{row.dateReceived}</TableCell>

                      <TableCell>{row.patientId}</TableCell>

                      <TableCell>{row.patientName}</TableCell>

                      <TableCell>{row.natureOfConsult}</TableCell>

                      <TableCell>{row.bookingDate}</TableCell>

                      <TableCell>{row.bookingTime}</TableCell>

                      <TableCell>{row.facrrmOnly}</TableCell>

                      <TableCell>
                        <i
                          className="fas fa-video primary-color cursor-pointer font-17"
                          onClick={event =>
                            callClinicPatient(event, row.bookingNumber)
                          }
                        ></i>

                        <i
                          className="fas fa-times text-danger cursor-pointer font-17 ml-3"
                          onClick={event =>
                            openCancelBookingModel(event, row.bookingNumber)
                          }
                        ></i>

                        <i
                          className="fas fa-check text-success cursor-pointer font-17 ml-3"
                          onClick={event =>
                            openCompleteBookingModel(event, row.bookingNumber)
                          }
                        ></i>
                      </TableCell>
                    </TableRow>
                  );
                }
              })}
              <TableRow className={loading ? "" : "d-none"}>
                <TableCell colSpan={7} className="text-center">
                  <CircularProgress disableShrink className="primary-loader" />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* Confirm call? */}
      <Model
        openModal={callClinicPatientModel}
        modalBodyContent="Are you sure you want to call?"
        okayText="Yes"
        cancelText="No"
        title="Call Clinic/Patient"
        useOneButton={false}
        okayEvent={callNow}
        cancelEvent={closeClinicModel}
      />

      {/* Cancel Booking */}
      <Model
        openModal={cancelBookingModel}
        modalBodyContent="Are you sure you want to cancel this booking?"
        okayText="Yes"
        cancelText="No"
        title="Cancel Booking"
        useOneButton={false}
        okayEvent={cancelBooking}
        cancelEvent={closeCancelBookingModel}
      />

      {/* Complete Booking Model */}
      <Model
        openModal={completeBookingModel}
        modalBodyContent="Are you sure you want to mark this booking as completed?"
        okayText="Yes"
        cancelText="No"
        title="Completed Booking"
        useOneButton={false}
        okayEvent={completeBooking}
        cancelEvent={closeCompleteBookingModel}
      />
    </Fragment>
  );
}
